import axios from "@/utils/axiosHelper";
// 初始化数据
export const onGetInitDataAPI = params => {
  return axios(
    { url: "/cherry/call/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 帮助页初始化数据
export const onGetHelpInitDataAPI = params => {
  return axios(
    { url: "/cherry/call/help", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 用户点击更新数据
export const updateAPI = params => {
  return axios(
    { url: "/cherry/call/update", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 加入队伍
export const joinTeamAPI = params => {
  return axios(
    { url: "/cherry/call/join", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 创建队伍
export const createTeamAPI = params => {
  return axios(
    { url: "/cherry/call/create", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 奖励领取
export const getAwardAPI = params => {
  return axios(
    { url: "/cherry/call/reward", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 免密登录
export const secretFreeLoginApi = params => {
  return axios(
    { url: "/game/clock/login", method: "POST", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/sakura/recall/api.js